module.exports = __webpack_public_path__ + "img/brasao-consultor-lider.d03d3325.png";